import {
  EdhNtfctnType,
  EdhPrtclInfo,
  IfStrtMthd,
} from "../../../services/component/get-component/GetComponentResponse";
import { EdhProtocolCombination } from "../../../services/data-list/get-edh-protocol-combination-list/GetEdhProtocolCombinationListResponse";
import { Option } from "../../../util/option";

export type ComponentEditDialogState = {
  isShow: boolean;
  isEdit: boolean;
  isUpdated: boolean;
  component: Component;
  formEditData: FormEditData;
  searchButtonDisabled: boolean;
  edhProtocolCombination: EdhProtocolCombination[];
  dataList: {
    cpntOwnType: Option[];
    cpntAlctnType: Option[];
    edhProtcolList: Option[];
    startMethod: Option[];
    inboundNotificator: Option[];
    outboundNotificator: Option[];
    dynamicEdhProtocolList: Option[];
  };
  formValidation: FormValidation;
  fieldPath: {
    cpntId: string;
    cpntName: string;
    cpntNameWtngChng: string;
    cpntDesc: string;
    gpgEncryptnFlg: string;
    useAssmdRoleFlg: string;
    useEdhCnvtrFlg: string;
    hubFlg: string;
    edhPrtclList: string;
    ifStrtMthdList: string;
    edhNtfctnTypeList: string;
    ediUsgFlg: string;
    updateDateTimeMCpnt: string;
  };
};

export type Component = {
  cpntId: string;
  cpntName: string;
  cpntNameWtngChng: string;
  cpntDesc: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  updateDateTimeMCpnt: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
  edhPrtclInfoList: EdhPrtclInfo[];
};

export type EdhPrtcl = {
  inOutTypeCd: string;
  edhPrtclTypeCd: string;
};

export type FormEditData = {
  edhPrtclList: string[];
  ifStrtMthdList: string[];
  inboundNotificatorList: string[];
  outboundNotificatorList: string[];
};

export type FormValidation = {
  cpntNameWtngChng: boolean;
  cpntDesc: boolean;
  gpgEncryptnFlg: boolean;
  useAssmdRoleFlg: boolean;
  useEdhCnvtrFlg: boolean;
  hubFlg: boolean;
  edhPrtclList: boolean;
  ifStrtMthdList: boolean;
  inboundNotificatorList: boolean;
  outboundNotificatorList: boolean;
  ediUsgFlg: boolean;
};

export type PageNewState =
  | ComponentEditDialogState
  | ((prevState: ComponentEditDialogState) => ComponentEditDialogState);
